import { IServerSideGetRowsParams } from 'ag-grid-enterprise'
import { useAppDispatch, useAppSelector } from 'appState/store'
import { ObGrid } from '@outbound-ai/ursa'
import { FormatTime } from 'features/autocheck/utils'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { FILE_SHARE_DEFAULT_FILE_COLUMN, ROW_MODEL_TYPE } from '../constants'
import { updateCurrentFiles } from '../FileShareSlice'
import { FileShareTabType } from '../types/FileShareEnums'
import { createFileShareServerSideDataSource } from '../utils/grid'
import { NoContentFiles } from '../utils/helper'
import { DeleteFile } from './DeleteFile'
import { FileShareDownloadFile } from './FileShareDownloadFile'

export const FileShareFileList = () => {
  const dispatch = useAppDispatch()
  const [gridApi, setGridApi] = useState<any>(null)
  const { root, refresh } = useAppSelector((state) => state.fileShare)
  useEffect(() => {
    if (refresh && gridApi) {
      const dataSource = createFileShareServerSideDataSource()
      gridApi.api.setGridOption('serverSideDatasource', dataSource)
      dispatch(updateCurrentFiles({ root: FileShareTabType.Files, refresh: false }))
    }
  }, [refresh, root])

  const onGridReady = async (params: IServerSideGetRowsParams) => {
    setGridApi(params)
    if (window.innerWidth > 1600) {
      params.api.sizeColumnsToFit()
    }
    dispatch(updateCurrentFiles({ root: FileShareTabType.Files }))
    const dataSource = createFileShareServerSideDataSource()
    params.api.setGridOption('serverSideDatasource', dataSource)
  }

  const onFirstDataRendered = (params: any) => {
    params.api.sizeColumnsToFit()
    window.setTimeout(() => {
      const colIds = params.api.getColumns().map((col: any) => col.getColId())
      params.api.autoSizeColumns(colIds)
    })
  }

  return (
    <Div>
      <div className="grid">
        <ObGrid
          reactiveCustomComponents={true}
          columnDefs={FILE_SHARE_FILES_CONFIG as any}
          rowModelType={ROW_MODEL_TYPE}
          onGridReady={onGridReady as any}
          defaultColDef={FILE_SHARE_DEFAULT_FILE_COLUMN as any}
          paginationPageSize={20}
          cacheBlockSize={20}
          onFirstDataRendered={onFirstDataRendered}
          noRowsOverlayComponent={NoContentFiles}
        ></ObGrid>
      </div>
    </Div>
  )
}

const Div = styled.div`
  padding: 1.5rem 1rem 1.2rem 0;
  overflow: hidden;

  .grid {
    float: left;
    height: calc(100vh - 4.5rem - 4.25rem - 6.5rem - 40px);
    width: 100%;
    .cell-wrap-text {
      white-space: normal !important;
    }
    .comments-cell {
      width: 387px !important;
    }
  }
`

const FILE_SHARE_FILES_CONFIG = [
  {
    field: 'fileName',
    headerName: 'File Name',
    resizable: true,
    width: 180,
  },
  {
    field: 'userName',
    headerName: 'Uploaded By',
    width: 180,
    valueFormatter: (params: any) => {
      if (!params.value) return '---'
      const { firstName, lastName } = params.value
      return `${firstName} ${lastName}`
    },
  },
  {
    field: 'created',
    headerName: 'Upload Date & Time',
    width: 220,
    valueFormatter: (params: { value: string | number | Date }) => {
      return FormatTime(params.value)
    },
  },
  {
    field: 'comments',
    headerName: 'Comments',
    width: 387,
    wrapText: true,
    autoHeight: true,
    cellClass: 'comments-cell',
  },
  {
    field: '',
    headerName: '',
    width: 150,
    cellRenderer: FileShareDownloadFile,
  },
  {
    field: '',
    headerName: '',
    width: 150,
    cellRenderer: DeleteFile,
  },
]
